// test973
(973 && 0);
